function leftPadZero(num, size) {
  let numStr = String(num);
  while (numStr.length < size) {
    numStr = '0' + numStr;
  }
  return numStr;
}

export default function dateFormatter(timeStamp) {
  let temp='';
  if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
    temp=timeStamp.replace(/\-/g, '/');
  }else {
    temp=timeStamp
  }
  let date = new Date(temp);
  let YYYY = date.getFullYear();
  let MM = date.getMonth() + 1;
  let DD = date.getDate();
  let hh = date.getHours();
  let mm = date.getMinutes();
  return `${YYYY}年${MM}月${DD}日 ${leftPadZero(hh, 2)}:${leftPadZero(mm, 2)}`;
}



// WEBPACK FOOTER //
// ./src/utils/dateFormatter.js